export default {

	INVALID_COMPANY_ID_OR_COMPANY_NAME: 270403,
	INVALID_PHONE_NUMBER: 270427,
	INVALID_WEBSITE_URL: 270428,
	INVALID_COMPANY_COUNTRY: 270433,
	INVALID_COMPANY_INDUSTRY: 270429,
	INVALID_COMPANY_SIZE: 270430,
	INVALID_CLOUD_DRIVE_ADDED: 50104,
	INVALID_COMPANY_NAME: 270415,
	INVALID_EMAIL: 270423,
	INVALID_WORKSPACE_NAME: 270415,

	COMPANY_NAME_ALREADY_EXISTS: 270416,

	INSUFFICIENT_USER_RIGHTS: 270312,
	COMPANY_NOT_FOUND: 270302,
	USER_NOT_VALIDATED: 270324,
	DELETE_MYSELF: 270320,
	DELETE_MYSELF_AS_ADMIN: 11048,
	FAILED_TO_CREATE_COMPANY_SUBSCRIPTION: 11053,
	NO_ACTIVE_SUBSCRIPTION: 11056,

	PAYMENT_PROCESSING_FAILED: 13005,
	PAYMENT_METHOD_VERIFICATION_FAILED: 13006,
	PAYMENT_METHOD_NOT_PRESENT: 13007,
	PAYMENT_GATEWAY_CURRENCY_INCOMPATIBLE: 13008,
	PAYMENT_PROVIDER_INTERNAL_ERROR: 13001,//CB is the provider in this case
	SUBSCRIPTION_ALREADY_EXISTS: 13002,
	SUBSCRIPTION_PLAN_CURRENCY_MISMATCH: 11065,
	THE_NUMBER_OF_THE_USERS_CANNOT_BE_LESS_THAN_THE_NUMBER_OF_USERS_OF_COMPANY: 12133,

	WORKSPACE_NAME_ALREADY_EXISTS: 270305,
	CLOUD_STORAGE_ITEM_NOT_FOLDER: 270327,
	CLOUD_STORAGE_FOLDER_NOT_WRITABLE: 270328,

	COMPANY_ALREADY_EXISTS: 270403,
	USER_ALREADY_EXISTS_IN_COMPANY: 270438,
	DOMAIN_ALREADY_EXISTS_IN_COMPANY: 270439,
	FOLDER_ALREADY_EXISTS_IN_COMPANY: 270440,
	SMART_FIELD_ALREADY_EXISTS_IN_COMPANY: 270441,
	WORKSPACE_ALREADY_EXISTS_IN_COMPANY: 270442,
	USER_ALREADY_EXISTS_IN_WORKSPACE: 270443,
	DOMAIN_ALREADY_EXISTS_IN_WORKSPACE: 270444,

	WRONG_FONT_TYPE_UPLOADED: 180008,
	CHECKSUM_CONFLICT_INVALID_FONT_FILE: 180013,
	WAITING_FOR_API: 6035,

	USER_AUTHENTICATION_REQUIRED: 10028,
	SEGMENT_NOT_LOADED: 1001,
	UNKNOWN: 6000,
	OFFLINE: 6017,// client side OFFLINE/CORS/aborted/webdev blocked
	XHR_FAILED: 6047, // not API error and not OFFLINE but could be 404
	CB_NOT_LOADED: 6048,
	REJECTED_API_STATUS_REQUEST: 6038,
	PAYMENT_PROVIDER_INTERNAL_COUPON_ERROR: 6056,

	WRONG_PASSWORD: 201105,
	EMAIL_ALREADY_USED: 201118,
	INVALID_EMAIL_FORMAT: 201101,
	INVALID_FIRST_NAME: 201124,
	INVALID_LAST_NAME: 201125,
	INVALID_PASSWORD: 201102,
	PASSWORDS_NOT_MATCHING: 201112,
	PASSWORD_ALREADY_USED: 201117,
	UNKNOWN_EMAIL: 201108,
	INVALID_TARGET_DOMAIN: 201104,// invalid req.body.host request property
	NOTIFICATION_SERVICE_INTERNAL_ERROR: 201122,
	METHOD_NOT_SUPPORTED: 200114,// checking existence of the target collection in database	 
	EMAIL_ASSOCIATED_TO_ANOTHER_USER: 201116,
	COUNTRY_CANNOT_BE_DETECTED: 12145,

	CRS_INFO_REQUEST_FAILED: 128001,
	CRS_INVALID_CREDENTIALS: 128002,
	CRS_CREDENTIALS_ALREADY_USED: 128003,

	FAILED_TO_GET_PAYMENT_COUPON: 12092,
	INVALID_COUPON_SET_ID: 270467,
	INVALID_COUPON_ID: 270468,

	INVALID_COUPON_CODE_ID: 12107, //check in MW that the couponId is not an empty string (/payment/chargebee/coupon route)
	FAILED_TO_RETRIEVE_COUPON: 12106, // non exposable error from other service in /payment/chargebee/coupon route
	COUPON_CODE_DOES_NOT_EXIST: 13010, //coming from CB, on /payment/chargebee/coupon route,

	FAILED_TO_CREATE_COMPANY_ADDON: 12091,
	FAILED_TO_TRIGGER_PAYMENT_FLOW: 11023,
	COUPON_CODE_ALREADY_EXISTS: 13009,

	// Invite users popup
	SUBSCRIPTION_PLAN_PROHIBITS_USER_MODIFICATION: 11067,
	FAILED_TO_ADD_USERS_TO_COMPANY: 11043,
	INVALID_USER: 270301,
	INVALID_USERS: 270410,

	// Member addons
	THE_MEMBERS_ADDON_QUANTITY_HAS_TO_BE_A_POSITIVE_NUMBER: 12134,
	COMPANY_DOES_NOT_HAVE_A_VALID_SUBSCRIPTION: 12129,
	NOT_ALLOWED_TO_BUY_EMPTY_SEATS_TO_THE_CURRENT_SUBSCRIPTION: 12128,
	FAILED_TO_MODIFY_MEMBERS_ADDON_OF_SUBSCRIPTION: 12132,
	INVALID_ADD_ADDON_PACKET1: 270346,
	INVALID_ADD_ADDON_PACKET2: 270465,
	INVALID_PAYMENT_ACCOUNT_ID: 270425,
	INVALID_PAYMENT_PRODUCT_ID: 270431,
	INVALID_UPDATE_ADDON_PACKET: 270345,
	INVALID_ADDON_USERS_ACTION: 270347,
	ADDON_DOES_NOT_EXIST1: 270348,
	ADDON_DOES_NOT_EXIST2: 13011, //coming from CB
	FAILED_TO_RETRIEVE_ADDON_DETAILS: 12136,
	INVALID_ADDON_ID: 12135, //The validity checked only on the MW side and only that the addonId is not an empty string	
	ALL_OF_THE_MEMBERS_ADDON_ALREADY_REMOVED: 12130,
	THE_QUANTITY_OF_THE_MEMBERS_ADDON_CANNOT_BE_LESS_THAN_THE_QUANTITY_OF_USERS_OF_COMPANY: 12131,

	// Estimate endpoint
	COMPANY_DOES_NOT_HAVE_AN_ACTIVE_SUBSCRIPTION: 12137,
	FAILED_TO_RETRIEVE_UPCOMING_INVOICE_ESTIMATION: 12138,

	INVALID_PLAN_ID: 12139, //The validity checked only on the MW side and only that the planId is not an empty string
	FAILED_TO_RETRIEVE_CREATE_SUBSCRIPTION_ESTIMATION: 12140,

	// MISC
	USER_NOT_FOUND: 270322,
	CUSTOMER_DOES_NOT_EXIST: 13012, //coming from CB
	USER_SERVICE_INTERNAL_ERROR: 270329,
	COMPANY_HAS_UNLIMITED_TEAM_SUBSCRIPTION: 12141,

	// Rate limit in variuos endpoints
	API_REQUEST_LIMIT_EXCEEDED: 13013,

	// Update externalIds endpoint
	EXTERNAL_IDS_INVALID_COMPANY_ID: 12070,
	EXTERNAL_IDS_MUST_BE_AN_ARRAY: 12155,
	EXTERNAL_IDS_TARGET_USER_IS_NOT_IN_THE_COMPANY: 12152,
	FAILED_TO_UPDATE_EXTERNAL_ID: 12151,
	DUPLICATE_MLS_IDS: 12166,
	USER_REACHED_THE_COMPANY_INVITATION_LIMIT: 12169
};


// WEBPACK FOOTER //
// ./src/errors/errorids.js